import TenantSurveyPhase from './TenantSurveyPhase.vue';

export default TenantSurveyPhase;
